import { FormSectionWithRows } from '@strata/react-form-section';
import {
    AddressDetailLabelValue,
    DetailLabelValuePair,
    PatientInfoList,
} from '@strata/react-label-value-pairs';

import { LiveReferral } from 'store/liveReferrals/liveReferralsHooks';
import { PrescriberDetails } from 'store/reference/referenceSlice';

interface PatientDetailsProps {
    selectedReferral?: LiveReferral;
    prescriberDetails?: PrescriberDetails;
}

export const PatientDetails = ({
    selectedReferral = undefined,
    prescriberDetails = undefined,
}: PatientDetailsProps) => (
    <FormSectionWithRows
        sectionTitle="Patient Details"
        isLoading={!prescriberDetails}
        rowOneContent={
            <>
                <AddressDetailLabelValue
                    style={{ width: '25%' }}
                    label="Location"
                    city={selectedReferral?.memberCity}
                    state={selectedReferral?.memberState}
                    zip={selectedReferral?.memberZip}
                />
                <DetailLabelValuePair
                    style={{ width: '25%' }}
                    label="Age"
                    value={selectedReferral?.memberAge}
                />
                <DetailLabelValuePair label="Diagnosis" value={selectedReferral?.diagnosisName} />
            </>
        }
        rowTwoContent={
            <PatientInfoList
                label="Attributes"
                values={selectedReferral?.valueCases}
                incentiveTotal={selectedReferral?.incentiveTotal}
            />
        }
        rowThreeContent={
            <>
                <DetailLabelValuePair
                    style={{ width: '25%' }}
                    label="Prescriber"
                    value={selectedReferral?.prescriberName}
                />
                <DetailLabelValuePair
                    style={{ width: '25%' }}
                    label="Prescriber NPI"
                    value={prescriberDetails?.prescriberNpi}
                />
                <DetailLabelValuePair
                    label="Practice"
                    value={prescriberDetails?.organizationName}
                />
            </>
        }
    />
);
